<template>
  <div class="page-container" style="height: 90%">
    <iframe  style="width: 100%;height: 100%" scrolling=auto src="/cts_system_www/html/system/permission/sysOfficeManage.html" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {
  data () {
    return {
      iframeWin: {}
    }
  },
  computed: {
    src () {
      return '/cts_system_www/html/system/permission/sysOfficeManage.html'
    }
  },
  methods: {
    loaded () {
      const cookie = document.cookie
      this.iframeWin.postMessage(cookie, '/cts_system_www/html/system/permission/sysOfficeManage.html')
    }
  },
  mounted () {
  }
}
</script>
